var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicesarrowicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.773 9.39792L7.14797 15.0229C7.0693 15.1017 6.96903 15.1553 6.85986 15.1771C6.75069 15.1988 6.63752 15.1877 6.53468 15.1451C6.43184 15.1024 6.34396 15.0303 6.28216 14.9377C6.22036 14.8451 6.18741 14.7363 6.1875 14.625V3.37495C6.18741 3.26364 6.22036 3.1548 6.28216 3.06221C6.34396 2.96963 6.43184 2.89747 6.53468 2.85485C6.63752 2.81224 6.75069 2.8011 6.85986 2.82284C6.96903 2.84459 7.0693 2.89823 7.14797 2.97699L12.773 8.60199C12.8253 8.65423 12.8668 8.71626 12.8951 8.78455C12.9234 8.85284 12.9379 8.92603 12.9379 8.99995C12.9379 9.07388 12.9234 9.14707 12.8951 9.21536C12.8668 9.28365 12.8253 9.34568 12.773 9.39792Z",
    fill: "#F15533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesarrowicon);
export default __webpack_public_path__ + "static/media/servicesarrowicon.5256a4fe905b4ba17ebfe5aa99418824.svg";
export { ForwardRef as ReactComponent };